var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { ConfiguredFlowError, ConfigError } from "../../util/Errors.js";
import { emailVerifyCallback } from "./emailVerifyCallback.js";
import sessionStorageHelper from "./sessionStorageHelper.js";
import { CONFIGURED_FLOW } from "./constants.js";
/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
const handleProxyIdxResponse = (settings) => __async(null, null, function* () {
  return Promise.resolve({
    rawIdxState: settings.get("proxyIdxResponse"),
    context: settings.get("proxyIdxResponse"),
    neededToProceed: []
  });
});
function startLoginFlow(settings) {
  return __async(this, null, function* () {
    const authClient = settings.getAuthClient();
    const {
      authParams
    } = settings.toJSON({
      verbose: true
    });
    const nonce = settings.get("nonce") || (authParams === null || authParams === void 0 ? void 0 : authParams.nonce);
    const idxOptions = __spreadValues({
      exchangeCodeForTokens: false
    }, nonce && {
      nonce
    });
    if (settings.get("proxyIdxResponse")) {
      return handleProxyIdxResponse(settings);
    }
    if (settings.get("overrideExistingStateToken")) {
      sessionStorageHelper.removeStateHandle();
    }
    if (settings.get("otp")) {
      return emailVerifyCallback(settings);
    }
    if (settings.get("oauth2Enabled")) {
      const meta = yield authClient.idx.getSavedTransactionMeta();
      if (!meta) {
        const flow = authClient.idx.getFlow();
        if (flow && flow === CONFIGURED_FLOW.PROCEED) {
          throw new ConfiguredFlowError("Unable to proceed: saved transaction could not be loaded", flow);
        }
        return authClient.idx.start(idxOptions);
      }
      return authClient.idx.proceed(idxOptions);
    }
    const stateHandleFromSession = sessionStorageHelper.getStateHandle();
    if (stateHandleFromSession) {
      try {
        var _idxResp$context, _idxResp$context$mess;
        const idxResp = yield authClient.idx.start(__spreadProps(__spreadValues({}, idxOptions), {
          stateHandle: stateHandleFromSession
        }));
        const hasError = ((_idxResp$context = idxResp.context) === null || _idxResp$context === void 0 ? void 0 : (_idxResp$context$mess = _idxResp$context.messages) === null || _idxResp$context$mess === void 0 ? void 0 : _idxResp$context$mess.value.length) > 0;
        if (hasError) {
          throw new Error("saved stateToken is invalid");
        }
        settings.set("stateToken", stateHandleFromSession);
        return idxResp;
      } catch (e) {
        sessionStorageHelper.removeStateHandle();
        return startLoginFlow(settings);
      }
    }
    const stateHandle = settings.get("stateToken");
    if (stateHandle) {
      return authClient.idx.start(__spreadProps(__spreadValues({}, idxOptions), {
        stateHandle
      }));
    }
    throw new ConfigError('Invalid OIDC configuration. Set "clientId" and "redirectUri" in the widget options.');
  });
}
export { startLoginFlow };
